import React from 'react'

export default function Pencil() {
    return (
        <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_171_2551)">
                    <path d="M27.6633 21.8183L18.18 12.3383L30.5167 0L40 9.48167L27.6633 21.8183ZM0 40L11.8767 37.6067L2.39667 28.125L0 40H0ZM3.30667 5.72L14.055 16.4633L4.75167 25.7667L14.2333 35.25L23.5383 25.945L34.3583 36.7617L36.6917 34.3817L5.64 3.34L3.30667 5.72Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_171_2551">
                        <rect width="40" height="40" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}
